<template>
  <div class="Trio-header">
    <hgroup class="Trio-title-group">
      <h1 class="Trio-main-title">{{ header.afford.title }}</h1>
      <h2 class="Trio-subtitle">{{ header.afford.desc }}</h2>
    </hgroup>
    <div v-if="step !== totalSteps.afford" class="Trio-step-bar">
      <a href="#" @click="previousStep" class="Trio-btn-back"
        ><i class="icon-arrow-back"></i
        ><span class="Trio-text-hidden">Atrás</span></a
      >
      <div class="Trio-step-box">
        <span class="Trio-text">{{ step }} / {{ totalSteps.afford }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "../store/index.js";

export default {
  name: "affordHeader",
  created() {
    Store.commit("ui/SET_STEP", 1);
  },
  computed: {
    header() {
      return Store.getters["ui/header"];
    },
    step() {
      return Store.getters["ui/step"];
    },
    totalSteps() {
      return Store.getters["ui/totalSteps"];
    },
  },
  methods: {
    previousStep() {
      let step = Store.getters["ui/step"];
      step = step - 1;
      if (step == 0) Store.commit("ui/CLEAR_ALL");
      else Store.commit("ui/SET_STEP", step);
    },
  },
};
</script>
